"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.createDefaultActiveRouteChecker = void 0; // for normal routes

var createDefaultActiveRouteChecker = function createDefaultActiveRouteChecker(currentPath) {
  return function (route) {
    var path = route.pathWithParams || (Array.isArray(route.path) ? route.path[0] : route.path);
    return path === currentPath;
  };
};

exports.createDefaultActiveRouteChecker = createDefaultActiveRouteChecker;
var _default = createDefaultActiveRouteChecker;
exports.default = _default;